import { initReactI18next } from 'react-i18next';

import i18nReport from 'i18next';
import Backend from 'i18next-http-backend';

import useLocalStore from 'src/store/useLocalStore';

import {
  isProdEnv,
  Language,
  pseudoizerLanguage,
} from 'src/models/Language.model';

const { reportLanguage, uiLanguage } = useLocalStore.getState();

i18nReport
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: isProdEnv ? Language.ENGLISH : pseudoizerLanguage,
    debug: !isProdEnv,
    ns: ['translation'],
    lng: reportLanguage ?? uiLanguage,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18nReport;
